import { Typography } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { useGetUserHobbiesQuery } from '@/generated/graphql'

import { UserInfoHobbyInner } from '../user-info-hobby/user-info-hobby.component'
import { UserInfoProps } from '../user-info.interface'

export const UserInfoEditModalHobby: React.FC<UserInfoProps> = ({ userId, readonly, viewerId }) => {
  const { t } = useTranslation()

  const { data } = useGetUserHobbiesQuery({
    variables: {
      userId,
      hobbyPagination: {
        last: 100,
      },
      evaluatedUserPagination: {
        last: 1000,
      },
    },
  })

  const hobbies = data?.user.hobbies?.edges.map(({ node }) => node) || []

  return (
    <div>
      <Typography.Title level={5}>{t('user.info.hobbies.title')}</Typography.Title>
      <UserInfoHobbyInner
        userId={userId}
        readonly={readonly}
        viewerId={viewerId}
        hobbies={hobbies}
        bodyStyle={{ padding: '0 15px' }}
      />
    </div>
  )
}
